module.exports = __webpack_public_path__ + "static/img/best-price.442f619.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/best-price.png
// module id = jk08
// module chunks = 1